import React from 'react';
import { Form, Input, InputNumber } from 'antd';

function formatCurrencyInput(value) {
    const numericValue = Number(value || 0);
    return `${new Intl.NumberFormat('vi-VN').format(numericValue)}đ`;
}

function parseCurrencyInput(value) {
    return `${value || ''}`.replace(/[^\d]/g, '');
}

export default function OrderPricingSummary(props) {
    const { onRecalculate, onDiscountBlur, discountRules = [] } = props;

    return (
        <section className="order-form-card order-pricing-card">
            <div className="order-form-card__header">
                <div className="order-form-card__icon"><i className="fas fa-receipt" /></div>
                <div className="order-form-card__title">Tổng quan thanh toán</div>
            </div>

            <div className="order-form-grid order-form-grid--two-columns">
                <Form.Item className="order-form-item" label="Phí vận chuyển" name="shipping_fee">
                    <InputNumber
                        min={0}
                        style={{ width: '100%', textAlign: 'right' }}
                        onBlur={onRecalculate}
                        formatter={formatCurrencyInput}
                        parser={parseCurrencyInput}
                    />
                </Form.Item>
                <Form.Item className="order-form-item" label="Giảm giá" name="discount" rules={discountRules}>
                    <InputNumber
                        min={0}
                        style={{ width: '100%', textAlign: 'right' }}
                        onBlur={onDiscountBlur || onRecalculate}
                        formatter={formatCurrencyInput}
                        parser={parseCurrencyInput}
                    />
                </Form.Item>
            </div>

            <Form.Item className="order-form-item order-form-item--total" label="Tổng tiền" name="total_price">
                <Input style={{ width: '100%', textAlign: 'right' }} disabled />
            </Form.Item>
        </section>
    );
}
